import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { type LayoutProps, PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'

export const pageUrl = '/[locale]/fundraising-events/[slug]?utm_campaign&utm_medium&utm_source'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl)
export type FundraisingEventPageProps = PageProps<typeof pageUrl>
export type FundraisingEventLayoutProps = LayoutProps<typeof pageUrl, 'modal' | 'admin'>
